import React from 'react';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';
import { ReactSVG } from 'react-svg';

interface ContractWizardTimelineProps {
  currentStep?: number;
}

const ContractWizardTimeline: React.FC<ContractWizardTimelineProps> = ({ currentStep = 1 }) => {
  const steps = [
    { id: 1, name: 'Add Coloc', icon: 'profile' },
    { id: 2, name: 'Pick Room', icon: 'house' },
    { id: 3, name: 'Pick Dates', icon: 'calendar' },
  ];

  return (
    <div className="contract-wizard-timeline flex justify-center">
      <div className="flex w-[400px] max-w-2xl items-center justify-between">
        {steps.map((step, idx) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center">
              {/* Icon circle */}
              <div
                className={`relative flex h-7 w-7 items-center justify-center rounded-full
                  ${
                    idx + 1 === currentStep
                      ? 'bg-J50 text-white'
                      : idx + 1 < currentStep
                      ? 'bg-gray-100 text-white'
                      : 'bg-gray-100 text-gray-400'
                  }
                `}
              >
                <ReactSVG
                  src={require(`@assets/icons/coloc-icons/${step.icon}.svg`)}
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `28`);
                    svg.setAttribute('height', `28`);
                  }}
                />
                {idx + 1 < currentStep && (
                  <IconSaxIcon
                    name="tick-circle-green"
                    size={20}
                    className="absolute mb-6 ml-4 text-white"
                    strokeColor="none"
                  />
                )}
              </div>

              {/* Label */}
              <span
                className={`font-N900 mt-2 text-[14px] font-medium ${
                  idx + 1 === currentStep
                    ? 'text-gray-900'
                    : idx + 1 < currentStep
                    ? 'text-gray-900'
                    : 'text-gray-500'
                }`}
              >
                {step.name}
              </span>
            </div>

            {/* Arrow between steps */}
            {idx < steps.length - 1 && (
              <div className="flex items-center">
                <IconSaxIcon name="arrow-wizard" size={28} strokeColor="none" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ContractWizardTimeline;
